import { IComponentOptions, IController } from 'angular';
import './gmc-banner.component.scss';
import { AuthService } from '../../../core/services/auth/auth.service';

class GmcBannerController implements IController {
  static $inject = ['AuthService'];
  orientation = 'horizontal' || 'vertical-three-links' || 'vertical-one-link';
  extraClasses;
  isCand;
  checkRole: boolean;

  constructor( private authService: AuthService) {
  }

  $onInit() {
  }

  $postLink() {
    if ( this.checkRole === true ) {
      this.isCand = this.authService.isCandidate();
    } else {
      this.isCand = true;
    }
  }

}

export const GmcBannerComponent: IComponentOptions = {
  controller: GmcBannerController,
  template: require('./gmc-banner.component.html'),
  bindings: {
    orientation: '@',
    extraClasses: '@',
    checkRole: '<'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-banner/gmc-banner.component.ts